import { environment } from './environments/environment';

import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { provideAnalytics, getAnalytics, ScreenTrackingService } from '@angular/fire/analytics';
// App Check: bloquea llamadas que no vengan de tu app (bots, scrapers, abuso de API)
import { provideAppCheck, initializeAppCheck, ReCaptchaEnterpriseProvider } from '@angular/fire/app-check';
import { getApp } from '@angular/fire/app';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './app/core/transloco.loader';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

// App Check debug token — SOLO en desarrollo (localhost). En prod usa el
// flujo reCAPTCHA Enterprise normal.
// `= true` hace que Firebase genere un token nuevo en runtime y lo imprima en
// la consola del navegador. Cópialo y regístralo a mano en:
//   Firebase Console → App Check → Manage debug tokens.
// NUNCA hardcodear el token aquí — quedaría expuesto en el repo.
if (!environment.production) {
  (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = '89C24EC1-9037-47D5-BD0C-8B70B31D9002';
}

import { leadersReducer } from './app/store/leaders/leaders.reducer';
import { videosReducer } from './app/store/videos/videos.reducer';
import { userReducer } from './app/store/user/user.reducer';
import { uiReducer } from './app/store/ui/ui.reducer';
import { LeadersEffects } from './app/store/leaders/leaders.effects';
import { VideosEffects } from './app/store/videos/videos.effects';

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideAnimations(),
    provideIonicAngular({ innerHTMLTemplatesEnabled: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),

    // Firebase — orden importante: App Check PRIMERO para que Firestore
    // ya tenga el token disponible desde el primer request.
    provideFirebaseApp(() => initializeApp(environment.firebase)),

    // App Check — registrado ANTES de provideFirestore/provideAuth.
    // Dev: abre DevTools → Console → copia el debug token impreso → regístralo en
    //   Firebase Console → App Check → Manage debug tokens.
    provideAppCheck(() =>
      initializeAppCheck(getApp(), {
        provider: new ReCaptchaEnterpriseProvider(environment.firebase['recaptchaSiteKey']),
        isTokenAutoRefreshEnabled: true,
      })
    ),

    provideAnalytics(() => getAnalytics()),
    ScreenTrackingService,
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions()),

    // HTTP + i18n
    provideHttpClient(withFetch()),
    provideTransloco({
      config: {
        availableLangs: ['es', 'en'],
        defaultLang: 'es',
        fallbackLang: 'es',
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader,
    }),

    // NgRx Store
    provideStore({
      leaders: leadersReducer,
      videos: videosReducer,
      user: userReducer,
      ui: uiReducer
    }),
    provideEffects([LeadersEffects, VideosEffects]),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: environment.production,
      connectInZone: true
    }),
  ],
});
